export default __webpack_public_path__ + "media/images/temporary/left-orders-5a93a1d4862b587dea9f349981f3523e.png";